/**
 *
 */
export declare interface IEpubCfiIndirection {
    from: Node | null;
    fromPath: URL | null;
    target: Node | null;
    targetPath: URL | null;
}
